import * as React from "react"
import { observer } from "mobx-react-lite"
import { Text } from "../../text/text"
import { IModalProps, Modal, Progress, View } from "native-base"
import { TextProps } from "../../text/text.props"
import { IProgressProps } from "native-base/lib/typescript/components/composites"
import { color, nativeBaseTheme } from "../../../theme"
import { Appearance } from "react-native"

export interface ProgressDialogProps extends IModalProps {
  colorScheme: "light"|"dark",

  title: string,
  titleTextProps?: TextProps,

  subtitle?: string,
  subtitleTextProps?: TextProps,

  progressValue?: number,
  progressProps?: IProgressProps
}

/**
 * Describe your component here
 */
export const ProgressDialog = observer(function ProgressDialog(props: ProgressDialogProps) {
  const {
    colorScheme = "light" || Appearance.getColorScheme(),
    title, titleTextProps,
    subtitle, subtitleTextProps,
    progressValue = 0, progressProps,
    ...rest
  } = props

  return <Modal
    testID="jala:id/progress-dialog"
    {...rest}
  >
    <View
      alignSelf="stretch"
      marginX="28px"
      paddingY="24px"
      paddingX="16px"
      borderRadius="16px"
      backgroundColor={colorScheme === 'light' ? nativeBaseTheme.colors.light["50"] : nativeBaseTheme.colors.dark["50"]}
    >
      <Text
        text={title}
        preset="title1"
        colorScheme={colorScheme}
        marginX="7px" marginY="8px"
        textAlign="center"
        color={color.palette.blueJalaDarker}
        {...titleTextProps}
      />
      {!!subtitle && <Text
        text={subtitle}
        preset="body2"
        colorScheme={colorScheme}
        marginX="7px" marginY="8px"
        textAlign="center"
        color={color.palette.gray700}
        {...subtitleTextProps}
      />}
      <View height="28px" justifyContent="center" marginY="8px">
        <Progress value={progressValue} height="5px" colorScheme="primary" {...progressProps} />
      </View>
    </View>
  </Modal>
})
